
import * as React from 'react'
import { Alert, Button, Col, Container, Form, ProgressBar, Row, Spinner } from 'react-bootstrap'
import * as _ from 'lodash'

import IosArrowForward from 'react-ionicons/lib/IosArrowForward'

import InputPhone from '../../components/InputPhone'
import { CurrentScreenT, ClientExtendsT } from './Booking'

import { copyObject } from '../../utils'
import { isEmail, isValidName, validatePassword } from '../../utils/validator'
import { FormControlProps } from 'react-bootstrap'
import { AxiosInstance } from '../../utils/RequestMethods'
import config from '../../constants/config'
import { ButtonLoading } from '../../components/ButtonLoading/ButtonLoading'
import InputValidate from './InputValidate'
import { ClientObj } from '../../types/Users'
import { loginSuccess, asyncUserData, asyncLoginSuccess } from '../../redux/actions'
import { useDispatch } from 'react-redux'


const styles = {
  left: {
    marginLeft: 0
  },
  required: {
    color: 'red'
  }
}


export type IScreenNewClientProps = {
  token: string
  back(): void
  email: string
  nextScreen(client: ClientExtendsT, tokenUser: string): void
  handle?: string
  // onChangeScreen(screen: CurrentScreenT)
  // onChangeScreenIndex(index: number)
}

const ScreenNewClient: React.FC<IScreenNewClientProps> = (props) => {
  const [validated, setValidated] = React.useState<boolean>(false)
  const [emailFound, setEmailFound] = React.useState<boolean>(false)
  const [successValidate, setSuccessValidate] = React.useState(false);
  const [processing, setProcessing] = React.useState<boolean>(false)
  const dispatch = useDispatch()
  const [client, setClient] = React.useState<ClientExtendsT>({
    ...ClientObj, ...{
      password: "",
      rePassword: "",
    }
  })
  const [formIsValid, setFormIsValid] = React.useState(false);

  const formRef = React.useRef(null)
  React.useEffect(() => {
    setClient((draft) => {
      draft.email = props.email
      return draft
    })
  }, []);

  const updateClient = (key: string, value: any) => {
    let tempClient = copyObject(client)
    tempClient[key] = value
    setClient(tempClient)

    setTimeout(() => {
      setSuccessValidate(checkValidity(tempClient))
    }, 10);

  }


  const checkValidity = (fieldsClient) => {
    // console.log("formRef", formRef)
    if (formRef && formRef.current) {
      let validityForm = formRef.current.checkValidity();
      // console.log("validityForm", (fieldsClient.rePassword != "" && fieldsClient.rePassword == fieldsClient.password))
      return validityForm && (fieldsClient.rePassword != "" && fieldsClient.rePassword == fieldsClient.password)
    }
    return false
  }


  const handleSubmit = async (client: ClientExtendsT, handle: string = null): Promise<string> => {
    let params = {
      handle: handle
    }
    params = { ...params, ...client }

    let options = {
      // data: params,
      headers: {
        'Authorization': `Bearer ${props.token}`
      }
    }

    try {
      let res = await AxiosInstance.post(`${config.url.clients}/company`, params, options)
      if (res && res.data) {
        setTimeout(() => {
          login(client.email, client.password)
        }, 100);
        return 'Client created.'
      } else {
        throw new Error("Client creation failed.");

      }
    } catch (error) {
      throw error;

    }
  }
  /**
    *
    * @returns
    */
  const login = async (email: string, password: string): Promise<string> => {
    let params = {
      email: email,
      password: password,
    };

    return AxiosInstance.post(`${config.url.wpJson}/wp/v2/token`, params).then((res) => {
      if (res && res.data) {

        dispatch(asyncLoginSuccess(res.data))

        setTimeout(() => {
          props.nextScreen(client, res.data.token)
        }, 50);
        return 'Login in.'

      }
    }).catch((error) => {
      throw error;
    })
  }



  return (
    <div>
      <ProgressBar
        now={1 / 3 * 100}
        style={{ marginBottom: 30 }}
        variant="info" />
      <p>
        No account is associated with the email <strong>{props.email}</strong>.
        To try another email,&nbsp;
        <a href="#" onClick={(): void => {
          props.back()
          // props.onChangeScreenIndex(0)
          // props.onChangeScreen('ClientIntro')
          // setEmailNotFound(false)
        }}>click here</a>
        , or continue with the sign-up process below.
      </p>
      <hr />
      <Form
        noValidate
        ref={formRef}
        validated={validated}

      // onSubmit={onSubmit}
      >
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>First Name <span style={styles.required}>*</span></Form.Label>
              <InputValidate
                required
                type='text'
                pattern="^[a-zA-Z-]+"
                value={`${_.startCase(client.firstName)}`}
                onValidate={(value) => {
                  return isValidName(value)
                }}
                onChangeValue={(value) => {
                  updateClient('firstName', value)
                }} />
              <Form.Control.Feedback type="invalid">
                You must input a valid first name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Last Name <span style={styles.required}>*</span></Form.Label>
              <InputValidate
                pattern="^[a-zA-Z-]+"
                required
                type='text'
                value={`${client.lastName}`}
                onValidate={(value) => {
                  return isValidName(value)
                }}
                onChangeValue={(value) => {
                  updateClient('lastName', value)
                }} />

              <Form.Control.Feedback type="invalid">
                You must input a valid last name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group>
          <Form.Label>Phone <span style={styles.required}>*</span></Form.Label>
          <InputPhone
            required
            defaultValue={`${client.phone}`}
            value={`${client.phone}`}
            //isValid={false}

            onChangeValue={(val: number): void => {
              updateClient("phone", val)
            }} />
          <Form.Control.Feedback type="invalid">
            You must input a valid phone number.
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group>
          <Form.Label>Password <span style={styles.required}>*</span></Form.Label>

          <InputValidate
            required
            type='password'
            // pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
            value={`${client.password}`}
            onValidate={(value) => {
              return validatePassword(value)
            }}
            onChangeValue={(value) => {
              updateClient('password', value)
            }} />

          <Form.Control.Feedback type="invalid">
            {client.password == "" ? `Required.` : 'Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters.'}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group>
          <Form.Label>Re-enter Password <span style={styles.required}>*</span></Form.Label>

          <InputValidate
            required
            type='password'
            // pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
            value={`${client.rePassword}`}
            onValidate={(value) => {
              return value != "" && value == client.password && validatePassword(value)
            }}
            onChangeValue={(value) => {
              updateClient('rePassword', value)
            }} />

          <Form.Control.Feedback type="invalid">
            {client.rePassword == "" ? `Required.` : 'Passwords must match.'}
          </Form.Control.Feedback>
        </Form.Group>



        <ButtonLoading
          disabled={processing || !successValidate}
          style={styles.left}

          type="submit"
          onClickFetching={async (e): Promise<string> => {
            e.preventDefault();
            e.stopPropagation()

            setValidated(true)
            if (!checkValidity(client)) {
              throw new Error("make sure input correct data in inputs.")
            }


            return await handleSubmit(client, props.handle)
          }}
          variant="success">

          Next
          <IosArrowForward
            color="white" />
        </ButtonLoading>
      </Form>
    </div>

  );
}
export default ScreenNewClient
